/**
 * Storage Module
 * 支持Local、Session、小程序的存储模块
 */
import Storage from '@fe/storage'

const storage = new Storage({
  type: 'local',
  prefix: process.env.APP_NAME + '_',
})

export default storage
